// TEMP CORE-9199 remove after Oct 30
import { Link, useParams } from 'react-router-dom'
import { JourneyView } from './JourneyView'
import { ShadowNotesPanel } from './ShadowNotesPanel'
import { useShadowSession } from './useShadowSession'

export const TempShadowSessionPage = () => {
  const { userId: userIdString } = useParams<{ userId: string }>()
  const userId = Number(userIdString)
  const { data, error } = useShadowSession(userId)
  const currentStep =
    data && 'data' in data.steps ? data.steps.data.currentStep : null

  return (
    <div className="flex gap-6 p-6">
      <div className="min-w-0 flex-1">
        <Link
          to={`/admin/finances/records/${userId}`}
          className="text-sm underline"
        >
          Back to user record
        </Link>
        <h2 className="my-3 text-2xl font-bold">
          Shadow session: user {userId}
        </h2>
        {error && (
          <p className="mb-3 text-red-600">Last refresh failed: {error}</p>
        )}
        {data ? <JourneyView data={data} /> : <p>Loading…</p>}
      </div>
      <div className="w-[420px] shrink-0">
        <ShadowNotesPanel userId={userId} currentStep={currentStep} />
      </div>
    </div>
  )
}
